let rootRanking = document.querySelector(':root');
let rankingContent = document.querySelectorAll(".ranking__content");

rankingContent.forEach((e) => {
    let rankingQuote = e.dataset.ranking;
    let rankingQuoteGraph = e.querySelector(".ranking__graph");;
    rankingQuoteGraph.style.width = (rankingQuote + "%");
});
